// Policies
export const GET_POLICIES_REQUEST = "GET_POLICIES_REQUEST";
export const GET_POLICIES_SUCCESS = "GET_POLICIES_SUCCESS";
export const GET_POLICIES_FAILURE = "GET_POLICIES_FAILURE";
